(function () {
    'use strict';

    let resizeTimer;

    function syncFavouriteBrandsSlider() {
        const slider = document.querySelector('#wls-favourite-brands .wls-trust-bar__slider');
        if (!slider || typeof window.Splide === 'undefined') return;

        const shouldAutoplay = window.innerWidth >= 1200;
        const instance = slider._wlsFavouriteBrandsSlider;

        if (!shouldAutoplay) {
            if (instance) {
                instance.destroy(true);
                slider._wlsFavouriteBrandsSlider = null;
            }
            return;
        }

        if (instance) return;

        const carousel = new Splide(slider, {
            type: 'loop',
            autoWidth: true,
            drag: 'free',
            focus: 0,
            gap: 0,
            pagination: false,
            arrows: false,
            autoScroll: {
                speed: 0.75,
                pauseOnHover: true,
                pauseOnFocus: true,
            },
        });

        carousel.mount(window.splide?.Extensions || {});
        slider._wlsFavouriteBrandsSlider = carousel;
    }

    function requestSync() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(syncFavouriteBrandsSlider, 160);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncFavouriteBrandsSlider);
    } else {
        syncFavouriteBrandsSlider();
    }

    window.addEventListener('resize', requestSync, { passive: true });
    document.addEventListener('shopify:section:load', syncFavouriteBrandsSlider);
})();
